import React from "react";

const Return = () => {
   return(<h1>This is Return</h1>);
};
export default Return;